import { Injectable } from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import {Prediction, PredictionRequest} from '@/app/core/models/bet/prediction';
import {environment} from '@/environments/environment';
import {Page} from '@/app/core/models/page';

@Injectable({
	providedIn: 'root'
})
export class PredictionService {

	private readonly SERVICE_URI = `${environment.backendUrl}/prediction`;

	constructor(private http: HttpClient) {}

	getPredictionsByUser(): Observable<Prediction[]> {
		return this.http.get<Prediction[]>(`${this.SERVICE_URI}/by-season`);
	}

	getPredictionsByUserPaginated(page: number = 0): Observable<Page<Prediction>> {
		const params = new HttpParams().set('page', page);
		return this.http.get<Page<Prediction>>(`${this.SERVICE_URI}/by-season/paginated`, { params });
	}

	createPrediction(predictionRequest: PredictionRequest): Observable<HttpResponse<void>> {
		return this.http.post<void>(`${this.SERVICE_URI}/create`, predictionRequest, { observe: 'response' });
	}
}
